import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const CalendarExclamationIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/calendar-exclamation"><path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M7.20002 1.3999C6.53728 1.3999 6.00002 1.93716 6.00002 2.5999V3.7999H4.80002C3.47454 3.7999 2.40002 4.87442 2.40002 6.1999V18.1999C2.40002 19.5254 3.47454 20.5999 4.80002 20.5999H19.2C20.5255 20.5999 21.6 19.5254 21.6 18.1999V6.1999C21.6 4.87442 20.5255 3.7999 19.2 3.7999H18V2.5999C18 1.93716 17.4628 1.3999 16.8 1.3999C16.1373 1.3999 15.6 1.93716 15.6 2.5999V3.7999H8.40002V2.5999C8.40002 1.93716 7.86277 1.3999 7.20002 1.3999ZM12.9 7.69991C12.9 7.20285 12.497 6.79991 12 6.79991C11.5029 6.79991 11.1 7.20285 11.1 7.69991V11.8999C11.1 12.397 11.5029 12.7999 12 12.7999C12.497 12.7999 12.9 12.397 12.9 11.8999V7.69991ZM13.2 16.3999C13.2 17.0626 12.6627 17.5999 12 17.5999C11.3372 17.5999 10.8 17.0626 10.8 16.3999C10.8 15.7372 11.3372 15.1999 12 15.1999C12.6627 15.1999 13.2 15.7372 13.2 16.3999Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default CalendarExclamationIcon;